const ACTIVE_WORKOUT_KEY = "myFitBeats_active_workout";

export interface ActiveWorkout {
  programId: string;
  programTitle: string;
  workoutName: string;
  week: number;
  workoutIndex: number;
  startedAt: number;
  elapsed: number;
  isPaused: boolean;
  // Rest timer state (persisted for navigation)
  restTimerExerciseId?: string | null;
  restTimerStartedAt?: number | null; // When timer was started
  restTimerDuration?: number | null; // Original duration in seconds
}

export function getActiveWorkout(): ActiveWorkout | null {
  try {
    const stored = localStorage.getItem(ACTIVE_WORKOUT_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    console.error("Failed to load active workout:", e);
  }
  return null;
}

export function setActiveWorkout(workout: ActiveWorkout | null) {
  try {
    if (workout) {
      localStorage.setItem(ACTIVE_WORKOUT_KEY, JSON.stringify(workout));
    } else {
      localStorage.removeItem(ACTIVE_WORKOUT_KEY);
    }
  } catch (e) {
    console.error("Failed to save active workout:", e);
  }
}

export function clearActiveWorkout() {
  try {
    localStorage.removeItem(ACTIVE_WORKOUT_KEY);
  } catch (e) {
    console.error("Failed to clear active workout:", e);
  }
}
